import type { Theme } from "~/common/mui";
import { C_OUTLINE_VARIANT } from "~/common/components/icon/Colors";

export const checkoutStyles = (theme: Theme) => ({
  ".scha__order-summary": {
    marginBottom: "60px",
    "&__param-column": {
      "& > * + *": {
        marginTop: "10px",
      },
    },
    "&__params": {
      flex: 2,
    },
    "&__totals": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      "&__actions": {
        display: "flex",
        justifyContent: "flex-end",
      },
    },
    "&__comment": {
      wordBreak: "break-all",
    },
    "& .scha__order-box__input.active .scha__order-box__input__label": {
      color: theme.palette.primary.main,
    },
    "& .scha__order-summary-paymentType": {
      color: theme.palette.text.secondary,
    },
    "& .scha__order-summary-credit-card": {
      cursor: "pointer",
    },
    "& .scha__order-summary-option-disabled": {
      color: "#c1c0c0",
    },
    "& .scha__order-summary-credit-card-expired": {
      marginLeft: "18px",
      color: theme.palette.error.main,
    },
    "& .scha__order-summary-add-credit-card": {
      color: theme.palette.primary.main,
      cursor: "pointer",
      marginLeft: "-2px",
      alignItems: "center",
      "& span": {
        marginLeft: "5px",
      },
      "& :hover": {
        color: "#005f14",
      },
    },
  },
  ".scha__order-summary-manage-credit-card-item": {
    border: `1px solid ${C_OUTLINE_VARIANT}`,
    borderRadius: "4px",
    padding: "16px",
    boxSizing: "border-box",
    position: "relative",
    "&__icon": {
      position: "absolute",
      top: "16px",
      right: "16px",
      width: "20px",
      height: "20px",
      color: theme.palette.primary.contrastText,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: theme.palette.primary.main,
      borderRadius: "50%",
      overflow: "hidden",
    },
    "&__error": {
      border: `1px solid ${theme.palette.error.main}`,
      borderRadius: "4px",
      padding: "16px",
      boxSizing: "border-box",
    },
    "&__active": {
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: "4px",
      padding: "16px",
      boxSizing: "border-box",
      position: "relative",
    },
    "&__title-options": {
      minWidth: "153px",
      marginRight: "14px",
      "& :last-child": {
        marginRight: 0,
      },
      "& span": {
        color: theme.palette.text.secondary,
      },
    },
    "&__btn-options": {
      width: "fit-content",
      marginRight: "24px",
      color: theme.palette.primary.main,
      "&:hover": {
        cursor: "pointer",
      },
    },
    "&__btn-options-disabled": {
      width: "fit-content",
      marginRight: "24px",
      color: theme.palette.text.primary,
      "&:hover": {
        cursor: "default",
      },
    },
    "&__default-options": {
      "& label": {
        width: "fit-content",
      },
    },
  },
  ".scha__checkout__add-credit-card-close-cvc": {
    color: theme.palette.info.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
  ".scha__checkout__delivery-option-block": {
    "&__list__option": {
      display: "flex",
      alignItems: "flex-start",
      alignContent: "center",
      cursor: "pointer",
      marginBottom: "8px",
      "&:last-child": {
        marginBottom: "0px",
      },
      "&__radio": {
        marginRight: "8px",
      },
      "&__label": {
        paddingTop: "2px",
      },
    },
  },
  ".scha__checkout__iframe-add-credit-card": {
    width: "100%",
    minHeight: "562px",
    border: "unset !important",
    marginTop: "20px",
  },
});
